<template>
  <footer>
    &copy; 2022 Ubiq Co., Ltd.
  </footer>
</template>

<script>
export default {
  name: 'FooterComponent'
}
</script>

<style scoped>
footer {
  text-align: center;
  color: #434345;
  padding-bottom: 30px;
}
</style>
